import store from "../store";

export default function auth({ next, router }) {
  if (
    !store.getters.isAuthenticated ||
    !(
      store.getters.isAdmin ||
      store.getters.isBasicAdmin ||
      store.getters.isOperator ||
      store.getters.isSubAgentOperator
    )
  ) {
    return router.push({ name: "login" });
  }
  return next();
}
